import React, { FunctionComponent, useMemo } from 'react'
import { useMap } from '@vis.gl/react-google-maps'
import { arrayToMap } from '../../../utils/data'
import { VehicleLocation } from 'server'
import AdvancedMarkerComponentReference from './AdvancedMarkerComponentReference/AdvancedMarkerComponentReference'
import { useLoaderData, useMatch } from '@tanstack/react-router'
import useDefaultVehicleFilter from '../../../hooks/data/useDefaultVehicleFilter'
import { createClusterer } from './utils/clusterer'
import { useQuery } from '@tanstack/react-query'
import { useFeathersClient } from '@strac/react-client-feathers'

interface IProps {
  userId: number | undefined
}

const CustomAdvancedMarkerClusterer: FunctionComponent<any> = (props: IProps) => {

  const { userId } = props

  const match = useMatch({ strict: false })
  const { vehicles, vehicleLocations } = useLoaderData({ from: match.routeId ?? '/' })
  const vehicleMap = arrayToMap(vehicles, 'vehicle_id')

  const map = useMap()

  const client = useFeathersClient()

  const { data: assettrakAccess } = useQuery({
    queryKey: ['assettrak-access', 'get', userId],
    queryFn: () => client.service('assettrak-access').get(userId || 0),
    enabled: !!userId
  })

  const clusterer = useMemo(() => {
    if (!map) return undefined
    return createClusterer(map)
  }, [map])

  const filteredVehicleLocations = useDefaultVehicleFilter(vehicles, vehicleLocations)

  return (
    <>
      {filteredVehicleLocations.map((vl: VehicleLocation) => {
        const vehicle = vehicleMap.get(vl.vehicle_id)
        return (
          <AdvancedMarkerComponentReference
            key={vl.vehicle_id}
            vehicle={vehicle}
            vehicleLocation={vl}
            clusterer={clusterer}
            assettrakAccess={assettrakAccess}
          />
        )
      })}
    </>
  )
}

export default CustomAdvancedMarkerClusterer
